import React from 'react';
import { translate } from '../../Services/translation';

const BrandsResults = ({ filteredBrands }) => {
  return (
    <ul className="quick-search-result__item-wrapper">
      {filteredBrands &&
        filteredBrands.slice(0, 4).map((item) => (
          <li key={`${item.name}-${item.url}`}>
            <a className="text-medium color-grey-900 lh-2" href={item.url}>
              {item.name}
            </a>
          </li>
        ))}
    </ul>
  );
};

export default BrandsResults;
